<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('AssignProductToContract')"
      :active.sync="showModal"
      id="assign-product-popup"
    >
      <div class="vx-card mb-4">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body card-body">
            <div class="vx-row">
              <div class="vx-col w-full">
                <form>
                  <div class="vx-row">
                    <div class="vx-col w-full md:w-1/2">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.name"
                        :label="$t('ProductName')"
                      />
                    </div>
                    <div class="vx-col w-full md:w-1/4">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.itemCode"
                        :label="$t('ItemCode')"
                      />
                    </div>
                    <div class="vx-col w-full md:w-1/4 mt-5">
                      <vs-button
                        type="filled"
                        class="float-right"
                        @click.prevent="submitFilter()"
                        >{{ $t("SubmitFilter") }}</vs-button
                      >
                      <vs-button
                        type="filled"
                        class="float-right ml-4"
                        id="reset-btn"
                        @click.prevent="resetForm"
                        >{{ $t("ResetFilter") }}</vs-button
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('ProductName'), sort: 'ProductName' },
              { title: $t('ItemCode'), sort: 'ItemCode' },
              { title: $t('WarrantyName'), sort: 'WarrantyName' },
              { title: $t('ColorName'), sort: 'ColorName' },
              { title: $t('ModelNumber'), sort: 'ModelNumber' },
              { title: $t('Action'), sort: 'Action' },
            ]"
            v-if="$tabHasPermission(permission316)"
          >
            <template slot-scope="{ row }">
              <td style="width: 50%">{{ row.name }}</td>
              <td style="width: 10%">{{ row.itemCode }}</td>
              <td style="width: 10%">{{ row.warrantyName }}</td>
              <td style="width: 10%">{{ row.colorName }}</td>
              <td style="width: 10%">
                <span v-if="row.modelNumber !== ''">{{ row.modelNumber }}</span
                ><span v-else>-</span>
              </td>
              <td style="width: 10%">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="view-btn"
                  @click.prevent="add(row.id)"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#assign-product-popup .vs-popup--content {
  overflow-y: scroll !important;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "saleManagement_Contract_Management_AssignProductPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    var id = this.$route.params.id;
    return {
      permission316: "GetAllExcludedContractProductsBy",
      gridDataSource: {
        type: "app",
        service: "/Sales/api/ProductQuery/excluded-contract-products/" + id,
      },
      gridSearchData: {
        keyword: "",
      },
      proInfo: {
        contractId: null,
        productIds: [null],
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  components: {
    DataGrid,
  },
  methods: {
    ...mapActions({
      assignContractProductsInfo: "sale/assignContractProductsInfo",
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        name: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    add(id) {
      var contractId = this.$route.params.id;
      this.proInfo = {
        contractId: contractId,
        productIds: [id],
      };
      this.assignContractProductsInfo(this.proInfo).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "محصول به قرارداد موردنظر افزوده شد!",
          color: "success",
        });
      });
    },
  },
};
</script>
